import { useState } from "react";

function App() {
  const [showModal, setShowModal] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    "/images/portfolio1.JPG",
    "/images/portfolio2.JPG",
    "/images/portfolio3.JPG",
    "/images/portfolio4.JPG",
    "/images/portfolio5.JPG",
    "/images/portfolio6.JPG"
  ];

  return (
    <div className="bg-black text-white relative overflow-hidden">

      {/* HERO */}
      <section className="h-screen flex flex-col justify-center items-center text-center relative overflow-hidden z-10">

        <img
          src="/images/hero.JPG"
          alt="Drone Background"
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="z-10 px-6">

          <h1 className="text-6xl md:text-8xl font-extrabold tracking-widest">
            DRONE-ON
          </h1>

          <p className="mt-6 text-gray-200 text-xl md:text-2xl tracking-wide">
            AERIAL & CONSTRUCTION PHOTOGRAPHY
          </p>

          <div className="mt-6 h-[3px] w-28 bg-blue-500 mx-auto"></div>

          <p className="mt-6 text-sm text-gray-400">
            FAA LICENSED & INSURED
          </p>

          {/* LOWER BUTTONS */}
          <div className="mt-32 flex flex-col items-center gap-4">

            <button
              onClick={() => setShowGallery(true)}
              className="px-10 py-4 border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-black transition duration-300 tracking-widest text-sm"
            >
              VIEW PORTFOLIO
            </button>

            <button
              onClick={() => setShowModal(true)}
              className="px-10 py-4 border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-black transition duration-300 tracking-widest text-sm"
            >
              CONTACT US
            </button>

          </div>

        </div>

      </section>

      {/* SERVICES (YOUR ORIGINAL — UNTOUCHED) */}
      <section className="py-40 px-6 bg-black text-center relative z-10">

        <h2 className="text-5xl md:text-7xl font-extrabold tracking-widest mb-6">
          SERVICES
        </h2>

        <div className="h-[4px] w-32 bg-blue-500 mx-auto mb-24"></div>

        <div className="grid md:grid-cols-3 gap-12 max-w-7xl mx-auto">

          {/* CARD */}
          <div className="group relative bg-white/5 border border-white/10 p-12 text-left backdrop-blur-md transition duration-500 hover:-translate-y-4 hover:border-blue-500">

            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-blue-500/20 via-transparent to-blue-500/20 blur-2xl"></div>

            <h3 className="relative text-3xl font-bold mb-6 tracking-widest group-hover:text-blue-400 transition">
              AERIAL PHOTOGRAPHY
            </h3>

            <p className="relative text-gray-200 text-xl leading-relaxed mb-8">
              High-resolution drone imagery designed to showcase properties,
              developments, and landscapes from a powerful aerial perspective.
            </p>

            <ul className="relative space-y-4 text-gray-300 text-lg">
              <li>• Real estate listings</li>
              <li>• Waterfront properties</li>
              <li>• Commercial developments</li>
              <li>• Large estates & homes</li>
            </ul>

          </div>

          {/* CARD */}
          <div className="group relative bg-white/5 border border-white/10 p-12 text-left backdrop-blur-md transition duration-500 hover:-translate-y-4 hover:border-blue-500">

            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-blue-500/20 via-transparent to-blue-500/20 blur-2xl"></div>

            <h3 className="relative text-3xl font-bold mb-6 tracking-widest group-hover:text-blue-400 transition">
              CONSTRUCTION PROGRESS
            </h3>

            <p className="relative text-gray-200 text-xl leading-relaxed mb-8">
              Consistent aerial documentation across every phase of construction,
              providing clear visual records and progress tracking.
            </p>

            <ul className="relative space-y-4 text-gray-300 text-lg">
              <li>• Pre-construction</li>
              <li>• Structural progress</li>
              <li>• Roofing & exterior</li>
              <li>• Infrastructure projects</li>
            </ul>

          </div>

          {/* CARD */}
          <div className="group relative bg-white/5 border border-white/10 p-12 text-left backdrop-blur-md transition duration-500 hover:-translate-y-4 hover:border-blue-500">

            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-blue-500/20 via-transparent to-blue-500/20 blur-2xl"></div>

            <h3 className="relative text-3xl font-bold mb-6 tracking-widest group-hover:text-blue-400 transition">
              INSPECTION & SAFETY
            </h3>

            <p className="relative text-gray-200 text-xl leading-relaxed mb-8">
              Safe and efficient inspection of hard-to-reach areas without the need
              for scaffolding or lifts.
            </p>

            <ul className="relative space-y-4 text-gray-300 text-lg">
              <li>• Roof inspections</li>
              <li>• Structural assessments</li>
              <li>• Site safety documentation</li>
              <li>• Night monitoring</li>
            </ul>

          </div>

        </div>

      </section>

      {/* CONTACT MODAL */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/70 z-50">

          <div className="bg-[#0a0a0a] border border-blue-500 p-10 text-center relative w-[90%] max-w-md">

            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-gray-400 hover:text-white text-xl"
            >
              ×
            </button>

            <h2 className="text-3xl font-bold mb-8">
              CONTACT
            </h2>

            <a href="mailto:testemail@gmail.com" className="block text-blue-500 mb-6 text-lg">
              droneonusa@gmail.com
            </a>

            <a href="tel:13053053053" className="block text-gray-300 text-lg">
              (772) 584-4967
            </a>

          </div>

        </div>
      )}

      {/* PORTFOLIO GRID */}
      {showGallery && (
        <div className="fixed inset-0 bg-black/95 z-50 overflow-y-auto p-6">

          <button
            onClick={() => setShowGallery(false)}
            className="fixed top-5 right-6 text-white text-3xl"
          >
            ×
          </button>

          <h2 className="text-4xl font-bold text-center mb-10 mt-10 tracking-widest">
            PORTFOLIO
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">

            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="portfolio"
                onClick={() => setSelectedImage(img)}
                className="w-full h-[300px] object-cover cursor-pointer hover:scale-105 transition duration-300"
              />
            ))}

          </div>

        </div>
      )}

      {/* IMAGE LIGHTBOX */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-[60] flex items-center justify-center p-6">

          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-5 right-6 text-white text-3xl"
          >
            ×
          </button>

          <img
            src={selectedImage}
            alt="expanded"
            className="max-w-full max-h-[90vh] object-contain"
          />

        </div>
      )}

    </div>
  );
}

export default App;